import React, { useEffect, useRef, useState } from 'react'
import PortalDemo from './portal-demo/portalDemo'
import styles from "./DemoScreen.module.css";
import AgentDemo from './agent-demo/agentDemo';
import MenuClose from './icons/menuClose';
import { useRouter } from 'next/router';

interface DemoProps {
  t: any;
  enum?: "portal" | "agent";
};

export default function Demo(props: DemoProps) {
  const { t, enum: initialTab } = props;
  const [activeTab, setActiveTab] = useState<"portal" | "agent">(initialTab ?? "portal");
  const [activeMenu, setActiveMenu] = useState(true)
  const menuRef = useRef<HTMLDivElement>(null);

  const handleAreaClick = (e: React.MouseEvent) => {
    if (activeMenu && menuRef.current && !menuRef.current.contains(e.target as Node)) {
      setActiveMenu(false);
    }
  };

  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab]);

  return (
    <div className={styles.demoScreenWrapper}>
      <div className={styles.quicTourWrapper}>
        <div className={styles.quickTourTitle}>{t("quickTour")}</div>
        {/* <div className={styles.quickTourTabWrapper}>
          <div className={`${styles.quickTourTab} ${activeTab === "portal" ? styles.activeTab : ""}`} onClick={() => setActiveTab("portal")}>
            Portal
          </div>
          <div className={`${styles.quickTourTab} ${activeTab === "agent" ? styles.activeTab : ""}`} onClick={() => setActiveTab("agent")}>
            Agent
          </div>
        </div> */}
        <div className={styles.quicTourContent} onClick={handleAreaClick}>
          <div ref={menuRef}
            className={`${styles.quickTourMenu} ${!activeMenu ? styles.quickTourMenuCollapsed : ""}`}
            onClick={(e) => {
              if (!activeMenu) {
                e.stopPropagation();
                setActiveMenu(true);
              }
            }}
          >
            <div className={styles.expandedContentWrapper}>
              <div className={styles.quickTourMenuTop}>
                <span>Ürünler Demo</span>
                <div className={styles.quickTourMenuTopIconWrapper}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveMenu(false);
                  }}>
                  <MenuClose width="18px" height="18px" />
                </div>
              </div>
              {/* <div className={styles.quickTourMenuLine}></div> */}
              <div className={styles.quickTourMenuTabWrapper}>
                <div className={`${styles.quickTourMenuTab} ${activeTab === "portal" ? styles.activeTab : ""}`} onClick={() => setActiveTab("portal")}>Portal</div>
                <div className={`${styles.quickTourMenuTab} ${activeTab === "agent" ? styles.activeTab : ""}`} onClick={() => setActiveTab("agent")}>Agent</div>
              </div>
            </div>
            <div className={styles.quicTourMenuButtonWrapper}>
              <div className={styles.quickTourMenuButton}>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <span className={styles.menuSmallText}>Menü</span>
            </div>
          </div>
          {activeTab === "portal" && <PortalDemo t={t} />}
          {activeTab === "agent" && <AgentDemo t={t} />}
          <div className={`${styles.quickTourContentBackground} ${activeMenu ? styles.quickTourContentBackgroundActive : ""}`}></div>
        </div>
      </div>
    </div>
  )
}
